import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'
export default genBasicStore('score_product')
